import { ButtonProps } from '@shopee/chatbot-ui/lib/components/Button';

export enum ButtonAction {
  JumpURL = 1,
  JumpNode,
  JumpFormstack,
  ToLiveAgent,
  JumpIntent,
  CancelOrder,
  ExtendShopeeGuarantee,
  Login,
  PopupOrderList = 10,
  AutoPopupDriverOrderList = 11,
  JumpIntentUseMessage,
  PopupWebform,
  ExpediteDelivery = 14,
  DeliveryInstructions,
  ExpediteDeliverySubmit,
  DeliveryInstructionsSubmit,
}

export enum ButtonType {
  Default,
  Primary,
  PrimaryOutlined,
  SecondaryOutlined,
  Frameless,
  // ==========================
  // 自定义样式，后端不会返回
  // ==========================
  Link = 1000,
  Text = 1001,
}

function hyphenate(str: string) {
  if (typeof str !== 'string') {
    return '';
  }

  const hyphenateRE = /\B([A-Z])/g;
  return str.replace(hyphenateRE, '-$1').toLowerCase();
}

export function getButtonAction(action: ButtonAction) {
  switch (action) {
    case ButtonAction.JumpURL:
    case ButtonAction.JumpFormstack:
      return 'redirection';
    case ButtonAction.JumpNode:
      return 'next';
    case ButtonAction.CancelOrder:
      return 'cancelOrder';
    case ButtonAction.ExtendShopeeGuarantee:
      return 'extendShopeeGuarantee';
    case ButtonAction.JumpIntent:
      return 'getIntent';
    case ButtonAction.ToLiveAgent:
      return 'toLiveAgent';
    case ButtonAction.Login:
      return 'login';
    case ButtonAction.PopupOrderList:
      return 'popupOrderList';
    case ButtonAction.AutoPopupDriverOrderList:
      return 'autoPopupDriverOrderList';
    case ButtonAction.JumpIntentUseMessage:
      return 'getIntentUseMessage';
    case ButtonAction.ExpediteDelivery:
      return 'expediteDelivery';
    case ButtonAction.ExpediteDeliverySubmit:
      return 'submitExpediteDelivery';
    case ButtonAction.DeliveryInstructions:
      return 'deliveryInstructions';
    case ButtonAction.DeliveryInstructionsSubmit:
      return 'submitDeliveryInstructions';
    case ButtonAction.PopupWebform:
      return 'popupWebform';
  }
}

export function getButtonType(type: ButtonType) {
  if (!Object.values(ButtonType).includes(type)) {
    return 'default';
  }

  return hyphenate(ButtonType[type]);
}
